module.exports = __webpack_public_path__ + "static/media/piney.cb331362.gif";